import { LineMoreHorizontal } from '@qr-front/icons/line-more-horizontal'
import { Button } from '@qr-front/ui/components/Button'
import { cn } from '@qr-front/ui/utils'
import { useAtomValue, useSetAtom } from 'jotai'

import { TQrDesign } from '@/generator/client'

import { previewColDef, selectColDef } from '../../columnsConfig'
import {
	mobileTableRowActionDialogAtom,
	mobileTableRowActionDialogTypeAtom,
	qrItemState,
} from '../../dialogsState'
import { TABLE_ROW_ACTION_TYPE } from '../../TableActions/Actions/actionOptions'
import { duplicatedQrHighlightAtom } from '../../tableState'
import { useCellValue } from '../../utils/cellValue'
import { useRenderDisplayCell } from '../../utils/renderDisplayCell'
import {
	CreateDate,
	Name,
	Status,
	Type,
	VerticalSeparator,
	WebsiteUrl,
} from '../commonElements'
import { PreviewCell } from '../PreviewCell'
import { MobileScans } from './MobileScans'

const Details = () => {
	return (
		<div className="flex flex-wrap items-center gap-x-4 gap-y-0">
			<Type />
			<VerticalSeparator className="h-4" />
			<MobileScans />
			<VerticalSeparator className="h-4" />
			<Status />
			<VerticalSeparator className="h-4" />
			<CreateDate />
		</div>
	)
}

export const TableRowTablet = ({ index }: { index: number }) => {
	const selectCheckbox = useRenderDisplayCell(selectColDef)

	const qrItem = useCellValue(previewColDef)
	const { id, updatedAt, qrDesign, content, uri, disabled } = qrItem

	const setQrItem = useSetAtom(qrItemState)
	const setTableRowDialogState = useSetAtom(mobileTableRowActionDialogAtom)
	const setTableRowActionDialogTypeState = useSetAtom(
		mobileTableRowActionDialogTypeAtom,
	)

	const highlightId = useAtomValue(duplicatedQrHighlightAtom)

	return (
		<div
			className={cn(
				'shadow-t-none hidden flex-row items-center gap-4 rounded-10 bg-white p-4 tablet:flex desktop:hidden',
				index === 0 &&
					id === highlightId &&
					'ring ring-inset ring-blue duration-300 animate-in fade-in zoom-in-90',
			)}
		>
			{selectCheckbox}
			<PreviewCell
				id={id}
				updatedAt={updatedAt}
				qrDesign={qrDesign as TQrDesign}
				content={content}
				uri={uri}
				disabled={disabled}
			/>
			<div className="flex w-0 shrink grow flex-col gap-2">
				<Name />
				<Details />
				<WebsiteUrl className="max-w-full truncate" />
			</div>
			<Button
				onClick={() => {
					setQrItem(qrItem)
					setTableRowDialogState(true)
					setTableRowActionDialogTypeState(TABLE_ROW_ACTION_TYPE.More)
				}}
				visual="text"
			>
				<LineMoreHorizontal />
			</Button>
		</div>
	)
}
